import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { EmptyObject } from 'types';
import { assignConsultee } from '../methods';
import { AssignConsulteeRequest } from '../types';

export const useAssignConsultee = (): UseMutationResult<
  EmptyObject,
  unknown,
  AssignConsulteeRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(assignConsultee, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultations] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultation] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getCaseDetails] });
    },
  });
};
